import React from 'react'

const AutomatedTemplate = ({ eventId, automatedTemplate, urlMapper }) => (
  <div className="list-group-item d-flex align-items-cents">
    <div className="preview flex-grow-1">
      <div className="description">
        { automatedTemplate.attributes.description }
        { automatedTemplate.attributes.eventType == "send_email" && <span className="badge bg-primary ms-1">Email</span> }
        { automatedTemplate.attributes.eventType == "send_sms" && <span className="badge bg-primary ms-1">SMS</span> }
      </div>
      <div className="text-muted">To: { automatedTemplate.attributes.recipient }</div>
      { automatedTemplate.attributes.eventType == "send_email" && <div className="text-muted">Subject: { automatedTemplate.attributes.subject }</div> }
      { automatedTemplate.attributes.eventType == "send_sms" && <div className="text-muted">Message: { automatedTemplate.attributes.smsBody }</div> }
    </div>
    <div className="ms-3 action-buttons">
      <div className="dropdown">
        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa fa-paper-plane"></i>
        </button>
        <ul className="dropdown-menu">
          <li>
            <a href={urlMapper.sendNowUrl(automatedTemplate.id)} className="dropdown-item" data-method="post" data-confirm="Do you want to send this message?">Send Now</a>
          </li>
          <li>
            <a href={urlMapper.addToReviewListUrl(automatedTemplate.id)} className="dropdown-item" data-method="post">Add to Review List</a>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <a href={urlMapper.showAutomatedEventUrl(automatedTemplate.id)} className="dropdown-item">Show Template</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default AutomatedTemplate
